{
  "BlockType": {
    "article__attachment": "Attachment",
    "article__audio": "Audio",
    "article__bodytext": "Text",
    "article__byline": "Byline",
    "article__card": "Card/info-box",
    "article__dateline": "Metadata",
    "article__media": "Images",
    "article__module": "Banner",
    "article__openinghours": "Opening hours",
    "article__person": "Person",
    "article__program": "Program",
    "article__quote": "Quote",
    "article__references": "Bibliography",
    "article__relations": "Link list",
    "article__sharing": "Sharing",
    "article__table": "Table",
    "article__title": "Heading and leadtext",
    "article__video": "Video",
    "calendar": "Calendar  (M24 1.0)",
    "calendar__navigator": "Time navigator  (M24 1.0)",
    "card": "Cards",
    "cardSearch": "Card module",
    "digitaltMuseum": "DigitaltMuseum (M24 1.0)",
    "dm_auto": "Digitalt Museum (auto)",
    "dm_filter_search": "Expanded w/ filter",
    "dm_manual": "Digitalt Museum (manual)",
    "dm_school": "School",
    "dm_single": "Digitalt Museum (single)",
    "employees_auto": "Employees (automatic)",
    "employees_manual": "Employees (manual)",
    "events_auto": "Events (automatic)",
    "events_manual": "Events (manual)",
    "flexible": "Widget",
    "form": "Form",
    "frontpage__module": "Banner",
    "kp": "KulturPunkt",
    "kp_owner": "KulturPunkt (museum)",
    "kulturpunkt": "KulturPunkt (M24 1.0)",
    "map": "Map (M24 1.0)",
    "map_v2": "Map",
    "member": "Membership data",
    "page_list_auto": "Automatic page list",
    "page_list_manual": "Manual page list",
    "productstatus": "Ticket sales",
    "search": "Search result",
    "ticket": "Online ticket",
    "ticket_validation": "Ticket scanner",
    "timeline": "Timeline"
  },
  "DMContentType": {
    "Architecture": "Architecture",
    "Artdesign": "Art/Design",
    "Article": "Article",
    "Audio": "Audio",
    "Building": "Building",
    "Construction": "Construction",
    "Event": "Event",
    "Exhibition": "Exhibition",
    "Fineart": "Artwork",
    "Folder": "Folder",
    "Investigation": "Investigation",
    "Media": "Media",
    "Museum": "Museum",
    "NavalVessel": "Naval vessel",
    "Organization": "Organization",
    "Person": "Person",
    "Photograph": "Photograph",
    "School": "School (All)",
    "school_digital": "School (digital)",
    "school_physical": "School (visit)",
    "Story": "Story",
    "Thing": "Thing",
    "TimePeriod": "Time period",
    "Video": "Video",
    "Virtual": "Virtual experience"
  },
  "DMSortTypes": {
    "artifact.ingress.title": "Title",
    "artifact.publishedDate": "Publishing date",
    "artifact.updatedDate": "Date last updated",
    "relevance": "Relvance",
    "score": "Relvance"
  },
  "Draggable": {
    "DropHereToAbort": "Drop here to abort",
    "MoveHere": "Move here"
  },
  "FilterLabel": "Apply filter to the list",
  "FilterOptions": {
    "created_by_id": "Uploaded by me",
    "missing_alt": "Alternative text missing",
    "none": "No filters"
  },
  "IntroSection": {
    "about": "A scrollytell section is used for simple messages across changing backgrounds (media element or background color (skin)). Changing backgrounds are achieved by using at least two consecutive scrollytell sections.",
    "limitations": "Note: This is a scrollytell section. Not all modules can or should be displayed here. We recommend keeping to simple text-based messages using the text, quote, and banner modules so the background media can stand out. Changing backgrounds are achieved by using at least two consecutive scrollytell sections."
  },
  "KulturioSchemaTypes": {
    "2": "KulturPunkt",
    "12": "Presentation",
    "13": "Kiosk view",
    "14": "Kiosk device",
    "32": "Puzzle"
  },
  "Languages": {
    "da": "Danish",
    "de": "German",
    "en": "English",
    "es": "Spanish",
    "fr": "French",
    "it": "Italian",
    "ja": "Japanese",
    "ko": "Korean",
    "nl": "Dutch",
    "nn": "Norwegian Nynorsk",
    "no": "Norwegian",
    "pl": "Polish",
    "ru": "Russian",
    "se": "Northern Sami",
    "sv": "Swedish",
    "zh": "Chinese"
  },
  "MainCategory": {
    "": "No category",
    "current_affairs": "Current affairs",
    "event": "Event",
    "exhibition": "Exhibition",
    "information": "Information",
    "knowledge": "Knowledge",
    "museum": "Museum/place of visit",
    "system": "System"
  },
  "MainLanguageSite": "Main language of the site",
  "MediaLicense": {
    "Description": {
      "AC 1": "This license allows no reuse without the creator's explicit permission.",
      "CC by": "This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format, so long as attribution is given to the creator. The license allows for commercial use.",
      "CC by-nc": "This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format for noncommercial purposes only, and only so long as attribution is given to the creator.",
      "CC by-nc-nd": "This license allows reusers to copy and distribute the material in any medium or format in unadapted form only, for noncommercial purposes only, and only so long as attribution is given to the creator.",
      "CC by-nc-sa": "This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format for noncommercial purposes only, and only so long as attribution is given to the creator. If you remix, adapt, or build upon the material, you must license the modified material under identical terms.",
      "CC by-nd": "This license allows reusers to copy and distribute the material in any medium or format in unadapted form only, and only so long as attribution is given to the creator. The license allows for commercial use.",
      "CC by-sa": "This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format, so long as attribution is given to the creator. The license allows for commercial use. If you remix, adapt, or build upon the material, you must license the modified material under identical terms.",
      "CC pdm": "This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format, with no conditions."
    },
    "FreeReuse": "Free reuse",
    "Label": {
      "": "Ingen lisens valgt",
      "AC 1": "Copyright - All Rights Reserved",
      "CC by": "Attribution",
      "CC by-nc": "Attribution, Noncommercial",
      "CC by-nc-nd": "Attribution, Noncommercial, No Derivatives",
      "CC by-nc-sa": "Attribution, Noncommercial, Share Alike",
      "CC by-nd": "Attribution, No Derivatives",
      "CC by-sa": "Attribution, Share Alike",
      "CC pdm": "No Copyright"
    },
    "NoReuse": "No reuse",
    "RestrictedReuse": "Restricted reuse"
  },
  "MediaResourceType": {
    "asset": "Assets",
    "audio": "Audio",
    "card": "Cards",
    "document": "Documents",
    "form": "Forms",
    "gif": "Animations",
    "image": "Images",
    "location": "Locations",
    "page": "Pages",
    "person": "People",
    "video": "Videos"
  },
  "SaveType": {
    "delete_draft": "Delete draft",
    "save": "$t(common:save)",
    "save_and_archive": "Save and archive",
    "save_and_publish": "Save and publish",
    "save_and_unpublish": "Save and unpublish",
    "save_as_copy": "Save as copy",
    "save_as_new_template": "Copy to new template",
    "save_as_new_version": "Save as new version"
  },
  "SectionType": {
    "article__body": "Content",
    "article__body_introSection": "Scrollytell section",
    "article__head": "Heading and leadtext",
    "article__links": "Card section",
    "grid__row": "Grid section",
    "page__grid": "Page list"
  },
  "SortDirectionLabel": "Select sorting direction",
  "SortDirections": {
    "asc": "Ascending",
    "date_asc": "Oldest first",
    "date_desc": "Newest first",
    "desc": "Descending",
    "text_asc": "A-Z",
    "text_desc": "Z-A"
  },
  "SortLabel": "Select sorting method",
  "SortOptions": {
    "created_at_asc": "Created (Oldest first)",
    "created_at_desc": "Created (Newest first)",
    "department_asc": "Department (A-Z)",
    "department_desc": "Department (Z-A)",
    "event_start_asc": "Event date, ascending",
    "event_start_desc": "Event date, descending",
    "first_name_asc": "First name (A-Z)",
    "first_name_desc": "First name (Z-A)",
    "last_name_asc": "Surname (A-Z)",
    "last_name_desc": "Surname (Z-A)",
    "relevance_desc": "Relevance",
    "status_asc": "Status, ascending",
    "status_desc": "Status, descending",
    "title_asc": "Title (A-Z)",
    "title_desc": "Title (Z-A)",
    "updated_at_asc": "Last updated (Oldest first)",
    "updated_at_desc": "Last updated (Newest first)",
    "uploaded_at_asc": "Uploaded (Oldest first)",
    "uploaded_at_desc": "Uploaded (Newest first)"
  },
  "SortTypeLabel": "Select sorting type",
  "SortTypes": {
    "created_at": "Created",
    "department": "Department",
    "first_name": "First name",
    "last_name": "Surname",
    "published_at": "Published",
    "title": "Title",
    "updated_at": "Last updated",
    "uploaded_at": "Uploaded"
  },
  "Statistics": "Statistics",
  "StatisticsIntro": "Standard enduser statistics for this site. Delivered by Plausible (without use of cookies).",
  "Status": {
    "archived": "Archived",
    "draft": "Draft",
    "deleted": "Deleted",
    "general": "General (published)",
    "hide_past_events": "Hide past events",
    "imported": "Imported",
    "include_past_events": "Past events",
    "no_draft": "No draft",
    "not_published": "Not published",
    "published": "Published",
    "published_not_listed": "Published (unlisted)",
    "planned_publishing": "Planned publishing"
  },
  "SubCategory": {
    "activity": "Activity",
    "adults": "Adults",
    "collection": "Collection",
    "concert": "Concert",
    "conference": "Seminar/Conference",
    "course": "Course/workshop",
    "current_affairs": "Current affairs",
    "digital": "Digital",
    "digital_event": "Digital event",
    "earlier": "Earlier",
    "exhibition": "Exhibition",
    "family": "Family",
    "family_event": "Family event",
    "kids": "Kids",
    "lecture": "Lecture/Talk",
    "market": "Market",
    "museum": "Museum/place of visit",
    "open_position": "Open position",
    "opening": "Opening",
    "performance": "Performance",
    "permanent": "Permanent",
    "press": "Press",
    "recurring_event": "Recurring event",
    "recurring_program": "Recurring program",
    "rental": "Rental",
    "research": "Research",
    "school": "School",
    "school_event": "School event",
    "services": "Services",
    "temporary": "Temporary",
    "touring": "Touring exhibition",
    "tour": "Tour",
    "upcoming": "Upcoming",
    "youth": "Youth"
  },
  "ViewType": {
    "grid": "Grid view",
    "list": "List view"
  },
  "WeekDay": {
    "fri": "Friday",
    "mon": "Monday",
    "sat": "Saturday",
    "sun": "Sunday",
    "thu": "Thursday",
    "tue": "Tuesday",
    "wed": "Wednesday"
  },
  "abort": "Abort",
  "add": "Add",
  "addAtBottom": "Add at the bottom",
  "addAtBottomShort": "Bottom",
  "addAtTop": "Add at the top",
  "addAtTopShort": "Top",
  "addPosition": "Where new modules go",
  "addX": "Add {{x}}",
  "all": "All",
  "appName": "Museum24 - Admin",
  "approved": "Approved",
  "auto": "Auto",
  "cancel": "Cancel",
  "changeItemSize": "Change item size",
  "clear": "Clear",
  "close": "Close",
  "copy": "Copy",
  "createdAt": "Created at",
  "cut": "Cut",
  "date": "Date",
  "decline": "Decline",
  "declined": "Declined",
  "default": "Default",
  "delete": "Delete",
  "deleteFailed": "An error occurred while deleting",
  "deleteSuccess": "Successfully deleted",
  "deleteWarning": "Are you sure you want to delete item?",
  "description": "Description",
  "done": "Done",
  "duplicate": "Duplicate",
  "error": "An error occurred",
  "eventData": "Event data",
  "exit": "Exit",
  "exitUnsavedWarning": "Are you sure you want to exit? You have unsaved changes.",
  "from": "From",
  "hide": "Hide",
  "hidden": "Hidden",
  "icon": "Icon",
  "ifOtherThanX": "If other than \"{{x}}\"",
  "inputLabel": "Label",
  "internalDescription": "Internal description",
  "language": "Language",
  "lastEdited": "Last edited",
  "loading": "Loading...",
  "loadingContent": "Loading content...",
  "menu": "Menu",
  "mergeWithNextSection": "Merge with the section below",
  "metadata": "Metadata",
  "moveDown": "Move down",
  "moveUp": "Move up",
  "name": "Name",
  "no": "No",
  "moduleClipboard": {
    "add": "Add to clipboard",
    "added": "{{name}} added to the clipboard",
    "button_one": "Clipboard ({{count}})",
    "button_other": "Clipboard ({{count}})",
    "clear": "Clear the clipboard",
    "from": "From \"{{page}}\", {{time}}",
    "notAllowedHere": "The module can't be placed in this section",
    "remove": "Remove from the clipboard",
    "title": "Clipboard"
  },
  "noContent": "No content",
  "none": "None",
  "noneSelected": "None selected",
  "ok": "Ok",
  "others": "Others",
  "owner": "Owner",
  "pasteName": "Paste {{name}}",
  "pending": "Pending",
  "place": "Place",
  "publishDate": "Publish date",
  "publishingStatus": "Publishing status",
  "remove": "Remove",
  "removeX": "Remove {{x}}",
  "removed": "Removed",
  "required": "Required",
  "save": "Save",
  "saveAndExit": "Save and exit",
  "saveFailed": "An error occurred while saving",
  "saveSuccess": "Successfully saved",
  "saved": "Saved!",
  "screenshotInstructionErrorMessage": "Take a screenshot of the whole window, including this error message, if you are going to report this error",
  "search": "Search...",
  "searchAndKeywords": "Search and keywords...",
  "searchAndCategories": "Search and categories...",
  "selectAll": "Select all",
  "selectFromList": "Select from the list",
  "settings": "Settings",
  "show": "Show",
  "ShowMore": "Show more",
  "showTitle": "Show title",
  "showPortal": "Open portal/site",
  "showPortalDesign": "Open portal/sites design overview",
  "showingXofY": "Showing {{x}} of {{y}}",
  "site": "Site",
  "siteChanged": "Changed site",
  "splitSection": "Split the section here",
  "splitSectionDone": "Cancel split",
  "splitSectionInfo": "Pick where to split the section. The modules below move to a new section with the same settings.",
  "splitSectionStart": "Split section",
  "status": "Status",
  "template": "Template",
  "title": "Title",
  "to": "To",
  "tryAgain": "Try again",
  "unselectAll": "Unselect all",
  "updatedAt": "Updated at",
  "userIcon": {
    "alert": "Warning",
    "date": "Calendar",
    "download": "Download",
    "email": "Email",
    "eye": "Eye",
    "info": "Information",
    "person": "Person",
    "phone": "Phone",
    "place": "Place",
    "ticket": "Ticket",
    "time": "Clock"
  },
  "validation": {
    "genericError": "This field is invalid",
    "max": "The value must be less than or equal to {{max}}",
    "maxLength": "Too many characters",
    "min": "The value must be greater than or equal to {{min}}",
    "minLength": "Too few characters",
    "pattern": "Invalid format",
    "required": "This field is required"
  },
  "yes": "Yes"
}
